import React from "react"
import { css } from "@emotion/css"

import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Typography from "@material-ui/core/Typography"
import { Surface } from "components/Surface"

type Column = {
  id: string
  label: string
  checked: boolean
  disabled?: boolean
}

type Props = {
  columns: Column[]
  onChange: (id: string) => void
  label?: string
}

export const TableColumnPicker = ({ columns, onChange, label }: Props) => {
  const sortedColumns = [...columns].sort((a, b) =>
    a.label.localeCompare(b.label),
  )

  return (
    <Surface variant="custom" size="custom">
      {label ? (
        <Typography variant="body1" className={styles.title}>
          {label}
        </Typography>
      ) : null}
      <Surface
        variant="custom"
        size="custom"
        display="grid"
        gridAutoFlow="row"
        gridRowGap="0"
      >
        {sortedColumns.map((col, idx) => (
          <ColumnRow key={`${col.id}.${idx}`} col={col} onChange={onChange} />
        ))}
      </Surface>
    </Surface>
  )
}

function ColumnRow(props: { col: Column; onChange: (id: string) => void }) {
  const { col, onChange } = props
  return (
    <FormControlLabel
      disabled={col.disabled}
      label={col.label}
      control={
        <Checkbox
          color="primary"
          checked={Boolean(col.checked)}
          onChange={(_) => onChange(col.id)}
          className={styles.checkbox}
        />
      }
    />
  )
}

const styles = {
  title: css`
    font-size: 0.8125rem;
    position: fixed;
  `,
  subtitle: css`
    margin: 1rem 0;
  `,
  checkbox: css`
    padding: 2px 9px;
  `,
}
